// Detects whether the visitor is browsing from the Philippines and returns
// the appropriate currency config for display + checkout.
export const getCurrency = () => {
  let ph = false;
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    if (tz === "Asia/Manila") ph = true;
    const langs = [navigator.language, ...(navigator.languages || [])].join(",").toLowerCase();
    if (/-ph\b|fil|tl-/.test(langs)) ph = true;
  } catch (e) {
    /* ignore */
  }
  return ph
    ? { code: "php", symbol: "₱" }
    : { code: "usd", symbol: "$" };
};

// Best-effort ISO country from the visitor's timezone/locale (delegates to the
// shared detector — timezone-first so an en-US locale doesn't mask PH users).
import { detectCountry } from "./countries";

export const getCountry = () => detectCountry();

export const fmtMoney = (symbol, n) =>
  `${symbol}${Number(n).toLocaleString(undefined, {
    minimumFractionDigits: Number.isInteger(n) ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
